module.exports = __webpack_public_path__ + "static/media/400040_02.a68f9bca.png";